import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/icon/logo.png'
import _imports_1 from '@/assets/images/login/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-0f4fd408"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layout-menu" }
const _hoisted_2 = {
  key: 0,
  class: "header-title"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header-title__main" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "header-logo",
    alt: ""
  })
], -1))
const _hoisted_4 = { class: "header-title__sub" }
const _hoisted_5 = {
  key: 1,
  class: "header-fold"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "header-fold__logo",
  alt: ""
}, null, -1))
const _hoisted_7 = [
  _hoisted_6
]

import { useRouter } from 'vue-router'
import {
  Histogram,
  Avatar,
  DocumentCopy,
  School,
  Stamp,
  Management,
  MessageBox,
  Cellphone,
  SetUp,
  Document,
  MostlyCloudy,
  CollectionTag,
  ReadingLamp
} from '@element-plus/icons-vue'
import { getCurrentInstance, onMounted, ref } from 'vue'
import { useMainStore } from '@/stores/main'
import { storeToRefs } from 'pinia'
import { authSystem } from '@/api/auth'
import { ElMessage } from 'element-plus'
import { getMenuTitle } from '@/utils/lang'


export default /*#__PURE__*/_defineComponent({
  __name: 'leftMenu',
  props: {
  // 是否收缩菜单
  isFold: { type: Boolean, default: false }
},
  setup(__props) {

const props = __props

const { t } = getCurrentInstance()?.appContext.config.globalProperties.$i18n
const { proxy } = getCurrentInstance() as any
const lang = localStorage.getItem('LANG') || proxy.$config.LANG
// 当前菜单
const store = useMainStore()
const { activePage } = storeToRefs(store)



// ********************* 菜单列表 ****************************
// 菜单列表
const menuList: any = ref([])

// 是否是KEBS账号
// const isKEBS = ref(false)
// 获取权限菜单与按钮权限
const getPermission = async () => {
  await authSystem().then((res: any) => {
    if (res.code === 100200) {
      store.PermissionMenuList = res.result.menu || []
      store.permissionsList = res.result.permissions || []
      if (res.result.roles) {
        const roles: any = []
        res.result.roles.forEach((element: any) => {
          roles.push(element.slug)
        })
        store.rolesList = roles // 角色 *必须有，需判断KEBS角色
      }
    } else {
      ElMessage.error(res.msg)
    }
  })
}
// 过滤隐藏的菜单
const filterMenu = (data: any) => {
  if (!data) return []
  return data.filter((item: any) => {
    if (item.status === 1) {
      item.children = filterMenu(item.children)
    }
    return item.status === 1
  })
}
// 获取菜单
const getMenu = async () => {
  if (!store.PermissionMenuList.length) return
  let menuData = []
  for (let i = 0; i < store.PermissionMenuList.length; i++) {
    const element: any = store.PermissionMenuList[i]
    if (element.slug === 'inspectionSystem') {
      menuData = element.children
      break
    }
  }
  const newMenu = await filterMenu(menuData)
  menuList.value = newMenu
}

// ********************** 菜单列表 ****************************
// 跳转页面
const router = useRouter()
const toPage = (parent: any, data?: any) => {
  router.push({
    path: data ? data.routePath : parent.routePath
  })
}
onMounted(async () => {
  if (store.PermissionMenuList && store.PermissionMenuList.length) {
    getMenu()
  } else {
    // 获取权限菜单及权限按钮
    await getPermission()
  }
})

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu = _resolveComponent("el-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_menu, {
      "default-active": _unref(activePage),
      collapse: __props.isFold
    }, {
      default: _withCtx(() => [
        (!__props.isFold)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)('header.systemName')), 1)
            ]))
          : _createCommentVNode("", true),
        (__props.isFold)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuList.value, (item, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
            (item.children && item.children.length)
              ? (_openBlock(), _createBlock(_component_el_sub_menu, {
                  key: 0,
                  index: item.routePath
                }, {
                  title: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        (item.icon === 'el-icon-document-copy')
                          ? (_openBlock(), _createBlock(_unref(DocumentCopy), {
                              key: 0,
                              class: "icon__menu"
                            }))
                          : _createCommentVNode("", true),
                        (item.icon === 'el-icon-school')
                          ? (_openBlock(), _createBlock(_unref(School), {
                              key: 1,
                              class: "icon__menu"
                            }))
                          : _createCommentVNode("", true),
                        (item.icon === 'el-icon-stamp')
                          ? (_openBlock(), _createBlock(_unref(Stamp), {
                              key: 2,
                              class: "icon__menu"
                            }))
                          : _createCommentVNode("", true),
                        (item.icon === 'el-icon-management')
                          ? (_openBlock(), _createBlock(_unref(Management), {
                              key: 3,
                              class: "icon__menu"
                            }))
                          : _createCommentVNode("", true),
                        (item.icon === 'el-icon-document')
                          ? (_openBlock(), _createBlock(_unref(Document), {
                              key: 4,
                              class: "icon__menu"
                            }))
                          : _createCommentVNode("", true),
                        (item.icon === 'el-icon-set-up')
                          ? (_openBlock(), _createBlock(_unref(SetUp), {
                              key: 5,
                              class: "icon__menu"
                            }))
                          : _createCommentVNode("", true),
                        (item.icon === 'el-icon-collection-tag')
                          ? (_openBlock(), _createBlock(_unref(CollectionTag), {
                              key: 6,
                              class: "icon__menu"
                            }))
                          : _createCommentVNode("", true),
                        (item.icon === 'el-icon-message-box')
                          ? (_openBlock(), _createBlock(_unref(MessageBox), {
                              key: 7,
                              class: "icon__menu"
                            }))
                          : _createCommentVNode("", true),
                        (item.icon === 'el-icon-cellphone')
                          ? (_openBlock(), _createBlock(_unref(Cellphone), {
                              key: 8,
                              class: "icon__menu"
                            }))
                          : _createCommentVNode("", true),
                        (item.icon === 'el-icon-reading-lamp')
                          ? (_openBlock(), _createBlock(_unref(ReadingLamp), {
                              key: 9,
                              class: "icon__menu"
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024),
                    _createElementVNode("span", null, _toDisplayString(_unref(getMenuTitle)(item,_unref(t))), 1)
                  ]),
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (data, ind) => {
                      return (_openBlock(), _createBlock(_component_el_menu_item, {
                        index: data.routePath,
                        onClick: ($event: any) => (toPage(item, data)),
                        key: ind,
                        "default-active": _unref(activePage)
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(getMenuTitle)(data,_unref(t))), 1)
                        ]),
                        _: 2
                      }, 1032, ["index", "onClick", "default-active"]))
                    }), 128))
                  ]),
                  _: 2
                }, 1032, ["index"]))
              : (_openBlock(), _createBlock(_component_el_menu_item, {
                  key: 1,
                  index: item.routePath,
                  onClick: ($event: any) => (toPage(item)),
                  "default-active": _unref(activePage)
                }, {
                  title: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(getMenuTitle)(item,_unref(t))), 1)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        (item.icon === 'el-icon-histogram')
                          ? (_openBlock(), _createBlock(_unref(Histogram), {
                              key: 0,
                              class: "icon__menu"
                            }))
                          : _createCommentVNode("", true),
                        (item.icon === 'el-icon-avatar')
                          ? (_openBlock(), _createBlock(_unref(Avatar), {
                              key: 1,
                              class: "icon__menu"
                            }))
                          : _createCommentVNode("", true),
                        (item.icon === 'el-icon-message-box')
                          ? (_openBlock(), _createBlock(_unref(MessageBox), {
                              key: 2,
                              class: "icon__menu"
                            }))
                          : _createCommentVNode("", true),
                        (item.icon === 'el-icon-cellphone')
                          ? (_openBlock(), _createBlock(_unref(Cellphone), {
                              key: 3,
                              class: "icon__menu"
                            }))
                          : _createCommentVNode("", true),
                        (item.icon === 'el-icon-mostly-cloudy')
                          ? (_openBlock(), _createBlock(_unref(MostlyCloudy), {
                              key: 4,
                              class: "icon__menu"
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["index", "onClick", "default-active"]))
          ], 64))
        }), 128))
      ]),
      _: 1
    }, 8, ["default-active", "collapse"])
  ]))
}
}

})